import { render, staticRenderFns } from "./CheckingAffiliates.vue?vue&type=template&id=907e5722&"
import script from "./CheckingAffiliates.vue?vue&type=script&lang=ts&"
export * from "./CheckingAffiliates.vue?vue&type=script&lang=ts&"
import style0 from "./CheckingAffiliates.vue?vue&type=style&index=0&id=907e5722&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports